import { React, useState, useEffect } from "react";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../seller-apis/api";
import { rejectedProducts } from "../../seller-apis/apidataField";
import PaginationCom from "../common/Pagination";
import NotAprrPCard from "../common/NotAprrPCard";
import "../inventry.css";
import { variables } from "../../Variables.json";
import { NavLink } from "react-router-dom";
import Popup from "../common/Popup";
import { useAlert } from "react-alert";
var globalFilter = {
  pageNo: 1,
};
const Rejected = () => {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();
  const [rejectedProductsList, setrejectedProductsList] = useState([]);
  const [rejRecords, setrejRecords] = useState();

  // Pagination related

  const [compforPaginationweb, setcompforPaginationweb] = useState("rejPro");
  const [selectedPage, setselectedPage] = useState(1);
  // Loader state

  const [loaderProductReject, setloaderProductReject] = useState("block");

  // Web search
  const [searchPro, setsearchPro] = useState();

  // Detail Popup

  const [isDetailPopupVis, setisDetailPopupVis] = useState("none");
  const [currdetailId, setcurrdetailId] = useState(0);

  const [removeFilterClass, setremoveFilterClass] = useState(
    "invent_remove_filter_btn"
  );
  const [searchType, setSearchType] = useState("Product Name");

  useEffect(() => {
    globalFilter = {
      pageNo: 1,
    };
    let filter = {
      pageNo: "1",
    };

    // Rejected Products
    api.product
      .vExPrdReqRetrieveAll(rejectedProducts(filter))
      .then((res) => {
        console.log(res);
        setrejectedProductsList(res.data);
        setrejRecords(res.totalRecords);
        setloaderProductReject("none");
      })
      .catch((err) => {
        console.log(err);
        setloaderProductReject("none");
      });
  }, []);

  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("Loaderrejected");
    loaderDiv.classList.add("loader-bt");
    setloaderProductReject("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setloaderProductReject("none");
    outerdiv.classList.remove("div-bk");
  }

  // Search on enter web

  function checkevent(e) {
    if (e.keyCode === 13) {
      if (searchPro !== "" && searchPro !== undefined) {
        console.log(globalFilter, globalFilter.productFilters);
        globalFilter.pageNo = selectedPage;
        // globalFilter.productFilters = {
        //   ...globalFilter.productFilters,
        //   productName: searchPro,
        // };
        let ordersearchFilter=searchType!='sku'?{"productName": searchPro}:{"SKU": searchPro};
                globalFilter.productFilters = {
                    ...ordersearchFilter,
                }
        applyLoader();
        setselectedPage(1);
        setcompforPaginationweb("rejsearchPro");
        // Rejected Products
        api.product
          .vExPrdReqRetrieveAll(rejectedProducts(globalFilter))
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn_active");
            setrejectedProductsList(res.data);
            setrejRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      } else if (compforPaginationweb !== "rejPro") {
        applyLoader();
        globalFilter.pageNo = selectedPage;
        globalFilter.productFilters = {};
        setselectedPage(1);
        setcompforPaginationweb("rejPro");
        // Rejected Products
        api.product
          .vExPrdReqRetrieveAll(rejectedProducts(globalFilter))
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn");
            setrejectedProductsList(res.data);
            setrejRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      }
    }
  }

  // search product btn web
  function searchProdBtnweb() {
    if (searchPro !== undefined && searchPro !== "") {
      globalFilter.productFilters = {
        ...globalFilter.productFilters,
        productName: searchPro,
      };
      applyLoader();
      setselectedPage(1);
      setcompforPaginationweb("rejsearchPro");
      globalFilter.pageNo = selectedPage;
      api.product
        .vExPrdReqRetrieveAll(rejectedProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn_active");
          setrejectedProductsList(res.data);
          setrejRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    } else if (compforPaginationweb !== "rejPro") {
      applyLoader();
      globalFilter.productFilters = {};
      setselectedPage(1);
      globalFilter.pageNo = selectedPage;
      api.product
        .vExPrdReqRetrieveAll(rejectedProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn");
          setrejectedProductsList(res.data);
          setrejRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          setloaderProductReject("none");
          removeLoader();
        });
    }
  }

  // Pagination function

  function paginate(data) {
    setcurrdetailId(0);
    globalFilter.pageNo = data.number;
    setselectedPage(data.number);
    applyLoader();
    // Rejected Products
    api.product
      .vExPrdReqRetrieveAll(rejectedProducts(globalFilter))
      .then((res) => {
        setrejectedProductsList(res.data);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }

  // Show detail

  function showDetail(id) {
    setcurrdetailId(id);
    setisDetailPopupVis("block");
  }

  function setpopupVisibilityDetail() {
    setisDetailPopupVis("none");
  }

  // Request new Price

  function requestnewPrice(id, gst) {
    let filter = {
      pageNo: selectedPage,
    };
    let ele = document.getElementById("req_price_again" + id);
    if (ele.value === "" || ele.value === undefined || ele.value < 1) {
      alert.info("Please enter a valid price");
    } else {
      if (
        rejectedProductsList[id].combination &&
        rejectedProductsList[id].combination.url &&
        rejectedProductsList[id].combination.url !== "notfound"
      ) {
        let chCom = {
          url: rejectedProductsList[id].combination.url,
          purchase_price: ele.value,
        };
        let data = {
          _id: rejectedProductsList[id].product._id,
          combination: chCom,
          exProductReqId: rejectedProductsList[id]._id,
          taxClass: gst,
        };

        api.product
          .addToExProduct(data)
          .then((res) => {
            alert.success("Request submitted successfully");
            // Rejected Products
            api.product
              .vExPrdReqRetrieveAll(rejectedProducts(filter))
              .then((res) => {
                console.log(res);
                setrejectedProductsList(res.data);
                setrejRecords(res.totalRecords);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => console.log(err));
      } else {
        let data = {
          _id: rejectedProductsList[id].product._id,
          purchase_price: ele.value,
          exProductReqId: rejectedProductsList[id]._id,
          taxClass: gst,
        };
        api.product
          .addToExProduct(data)
          .then((res) => {
            alert.success("Request submitted successfully");

            // Rejected Products
            api.product
              .vExPrdReqRetrieveAll(rejectedProducts(filter))
              .then((res) => {
                console.log(res);
                setrejectedProductsList(res.data);
                setrejRecords(res.totalRecords);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => console.log(err));
      }
    }
  }

  // Clear Filters

  function clearFilters() {
    if (searchPro !== undefined && searchPro !== "") {
      applyLoader();
      setselectedPage(1);
      globalFilter = {
        pageNo: "1",
      };
      setsearchPro("");
      // Rejected Products
      api.product
        .vExPrdReqRetrieveAll(rejectedProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn");
          setrejectedProductsList(res.data);
          setrejRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
        });
    }
  }

  return (
    <div className=" inventry-page" id="outer">
      <div className="pro_filt_cntnier d-flex">
        {/* <button className={removeFilterClass} onClick={() => clearFilters()}>
          Clear Filter
        </button> */}
        {/* <div class="">
                      <select className="pro_approved_srch_bar pr-4" onChange={(e)=>{setSearchType(e.target.value)}}>
                        <option value="product Name">Product Name</option>
                        <option value="sku">SKU</option>
                      </select>
                    </div>
        <input
          type="text"
          placeholder="Search for products..."
          className="pro_approved_srch_bar pr-4"
          value={searchPro}
          onKeyUp={(e) => checkevent(e)}
          onChange={(e) => setsearchPro(e.target.value)}
        ></input>
        <i
          className="fa fa-search srch_pro_filt_invent"
          aria-hidden="true"
          onClick={() => searchProdBtnweb()}
        ></i> */}
        {/* <input type='text' className='pl-1 filter_pro_invent_name' readOnly placeholder='All Products'></input><i className="fa fa-chevron-right fs-10 srch_pro_filt_invent_arrow" aria-hidden="true"></i> */}
        <NavLink exact to="/add-Product1">
          <button className="pro_add_pro_invent ms-2">+ Add Product</button>
        </NavLink>
        {/* <i class="fa fa-filter" aria-hidden="true"></i> */}
      </div>

      <div className="container_invent" id="orDeskContain">
        {/* New orders desktop */}
        <div class="tab table-responsive">
          {/* <Container> */}

          <table className="ord_table" style={{ width: "100%" }}>
            <thead>
              <tr className="table_ord_title_row">
                <th className="thead_title pt-2 pb-2" style={{ width: "7%" }}>
                  Product Image
                </th>

                <th className="thead_title pb-1" style={{ width: "20%" }}>
                  Product Name<br></br>
                </th>

                <th className="thead_title" style={{ width: "7%" }}>
                  Transfer price{" "}
                  <OverlayTrigger
                    key="transfer"
                    placement="bottom"
                    overlay={
                      <Tooltip
                        id={`tooltip-transfer`}
                        className="fs-10 order_page_tooltip"
                      >
                        <p className="fs-8 f-500 order_page_tooltip_1">
                          {variables.transferPriceText}
                        </p>
                      </Tooltip>
                    }
                  >
                    <i class="bi bi-info-circle ms-1"></i>
                  </OverlayTrigger>
                </th>

                <th className="thead_title" style={{ width: "10%" }}>
                  Reject Reason
                </th>

                <th className="thead_title" style={{ width: "10%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {rejRecords > 0 ? (
                rejectedProductsList.map((item, index) => {
                  let baseImg;
                  item.product.images.map((item) => {
                    if (item.baseImage === true) {
                      if (item.image.startsWith("products")) {
                        baseImg = item.image;
                      } else {
                        let img = item.image.substr("41");

                        baseImg = img;
                      }
                    }
                  });
                  if (
                    item.combination &&
                    item.combination.url &&
                    item.combination.url !== undefined &&
                    item.combination.url !== "" &&
                    item.combination.url !== "notfound"
                  ) {
                    var combarry = [];
                    var singleAttr = true;
                    if (item?.product?.combination?.[0]?.value.length > 1) {
                      singleAttr = false;
                    }

                    let obj = [];
                    item?.product?.combination.map((pitem, pindex) => {
                      if (
                        pitem.url === item?.combination.url &&
                        item?.combination?.purchase_price &&
                        item?.combination?.purchase_price !== undefined
                      ) {
                        if (!singleAttr) {
                          let com = "";
                          pitem?.value?.map((aitem, aindex) => {
                            com = com + aitem;
                            if (aindex !== pitem.value.length - 1) {
                              com = com + " x ";
                            }
                          });
                          combarry.push({
                            com: com,
                            price: item.combination.purchase_price,
                          });
                        } else {
                          let com = {
                            com: pitem.value[0],
                            price: item?.combination?.purchase_price,
                          };
                          combarry.push(com);
                        }
                      }
                    });
                    return (
                      <NotAprrPCard
                        id={index}
                        taxClass={item.product.taxClass}
                        SKU={item.product.SKU}
                        lead={item._id}
                        productName={item.product.productName}
                        price={item.purchase_price}
                        quantity={item.quantity}
                        image={baseImg}
                        combination={combarry}
                        remark={item.reason}
                        detail={showDetail}
                        requestnewPrice={requestnewPrice}
                        activePage={selectedPage}
                        from="rejectedRecords"
                      />
                    );
                  } else {
                    return (
                      <NotAprrPCard
                        id={index}
                        taxClass={item.product.taxClass}
                        SKU={item.product.SKU}
                        lead={item._id}
                        productName={item.product.productName}
                        price={item.purchase_price}
                        image={baseImg}
                        remark={item.reason}
                        activePage={selectedPage}
                        requestnewPrice={requestnewPrice}
                        detail={showDetail}
                        from="rejectedRecords"
                      />
                    );
                  }
                })
              ) : loaderProductReject ? (
                <></>
              ) : (
                <div className="card card-1">No Rejected Products</div>
              )}
            </tbody>
          </table>
          {/* </Container> */}
        </div>

        <div
          class="d-flex justify-content-center loader-bt"
          id="Loaderrejected"
        >
          <div
            class="spinner-border"
            role="status"
            style={{ display: loaderProductReject }}
          >
            <span class="sr-only"></span>
          </div>
        </div>

        <PaginationCom
          number={rejRecords}
          paginate={paginate}
          comp="rejectedPro"
          activ={selectedPage}
        />

        {/* Detail popup */}
        {rejectedProductsList.length > 0 ? (
          <div
            id="popupDetail"
            className="overlay"
            style={{ display: isDetailPopupVis }}
          >
            <Popup
              description={
                rejectedProductsList[currdetailId].product.description
              }
              sdescription={
                rejectedProductsList[currdetailId].product.shortDescription
              }
              descriptionNew={rejectedProductsList[currdetailId].product?.descriptionNew||[]}
              specificationNew={rejectedProductsList[currdetailId].product?.specificationNew||[]}
              name={rejectedProductsList[currdetailId].product.productName}
              // price={detailPPrice}
              SKU={rejectedProductsList[currdetailId].product.SKU}
              popupVisibility={setpopupVisibilityDetail}
              images={rejectedProductsList[currdetailId].product.images}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Rejected;
